
import Vue from 'vue'
import api from '@/services/api'

export default Vue.extend({
    async created() {
        await api.request('PATCH', 'users/me', {
            ratedCards: [],
        })
    },
    render(c) {
        return c('div')
    },
})
